<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="customersLimit"
				textCreate="Add customers"
				:flag="flag"
				page-title="Customers"
				:headers="headers"
				:settings="getSettings"
				:filtersList="customersFilters"
				:list="customersListMod"
				:defaultOrder="customersOrder"
				:defaultSort="customersSort"

				:totals="customersTotals"
				:total-pages="customersTotal"
				:limit-pages="customersLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				is-create
				is-settings
				:externalRefreshKey="externalRefreshKey"
				:externalResetKey="externalResetKey"
				:externalResetMode="externalResetMode"
		></main-table-all-back>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('customers')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<customer-form
				v-if="isCustomersForm"
				:id="customerId"

				:item="activeItem"
				:typeForm="typeForm"
				:permissions="permissions"
				@updateClose="onCloseDialog"
				@updateSave="onSave"
		></customer-form>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
// shared
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PAGE, PERMISSIONS } from "@/constants/constants";
import CustomerForm from "@/components/Maintenance/Customer/CustomerForm/CustomerForm.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import getUniqId from "@/helper/getUniqId";

export default {
	name: "Customers",
	mixins: [ settingsMixins, removeMixins ],
	components: {
		DialogRemove,
		CustomerForm,
		MainTableAllBack,
	},
	computed: mapGetters([
		"permissions",
		"previewLink",
		"customersListMod",
		"customersFilters",
		"customersTotals",
		"customersOrder",
		"customersLimit",
		"customersSort",
		"customersTotal",
	]),
	data: () => ({
		flag: PAGE.CUSTOMERS,
		isCommentsPopup: false,
		isCustomersForm: false,
		defaultFilter: null,
		activeTableFilters: null,
		customerId: null,
		activeItem: null,
		typeForm: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		externalRefreshKey: null, // Обновление списка с фильтрами
		externalResetKey: null, // Сброс фильтров
		externalResetMode: 'default', // Тип сброса фильтров ('default' сброс до дефолтніх фильтров) | ('empty' спрос всех фильтров)

	}),
	methods: {
		...mapActions([
			'getCustomers',
			'getCustomersFilters',
			'actionPreloader',
			'onExportLink',
			'onCustomersRemoveItem',
			'getMaintainceLogs',
			'setAlert',
		]),

		externalRefresh() {
			// обновить таблицу, сохранив текущие фильтры
			this.externalRefreshKey = getUniqId();
		},
		externalReset(mode) {
			// 'default' | 'empty' (default до дефолтних | empty усі фільтра)
			this.externalResetMode = mode;
			this.externalResetKey = getUniqId();
		},

		async onSave() {
			await this.getMaintainceLogs({ flag: PAGE.CUSTOMERS });
			this.isCustomersForm = false;
			this.externalRefresh();
		},

		onCloseDialog(isRefresh) {
			this.isCustomersForm = false;
			if (isRefresh) {
				this.externalRefresh();
			}
		},

		async onRemoveItem() {
			const { status } = await this.onCustomersRemoveItem(this.removeId);
			if (status) this.isRemove = false;
			this.externalRefresh();
		},

		async onEvent(flag) {
			if (flag === 'create') {
				this.isCustomersForm = true;
				this.customerId = null;
				this.typeForm = 'create';
			}
		},

		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getCustomers(filters);
			if (!isWithoutFilters) this.getCustomersFilters(filters);
		},

		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getCustomers(value);
					break;

				case "page":
					await this.onUpdateFilters(value, true);
					break;

				default:
					await this.onUpdateFilters(value);
			}
		},

		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'customers' });
		},

		async onClickButton({ key, item }) {
			this.activeItem = item;
			if (key === 'edit') {
				this.typeForm = key;
				if (this.permissions[PERMISSIONS.EDIT]) {
					this.customerId = item.id;
					this.isCustomersForm = true;
				}
			}

			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
					this.titleRemove = `Remove customer ?`;
					this.textRemove = `Are you sure you want to remove ${ item.name }? 🗑️`;
					this.isDialogRemove = true;
				}
			}
		},

		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onRemove() {
			const { id, name } = this.activeItem;
			const isSuccess = await this.onCustomersRemoveItem(id);
			if (isSuccess) {
				this.externalRefresh();
				this.setAlert({ type: "success", message: `Customer ${ name } was successfully removed 🗑️` });
			} else {
				this.setAlert({ type: "error", message: `Failed to remove ${ name }. Please try again later ⚠️` });
			}
			this.onCloseRemove();
		},

		onEdit({ line }) {
			this.activeItem = line;
			this.typeForm = 'edit';
			if (this.permissions[PERMISSIONS.EDIT]) {
				this.customerId = line.id;
				this.isCustomersForm = true;
			}
		},
	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>
